<header class="page-header">
  <div class="page-header__row">
    <h1>Report viewer</h1>
    <span class="badge">Beta</span>
  </div>
  <p class="lede">
    Upload a report package (.zip), legacy .xbrl/.xml, or CSV/JSON files from an xBRL-CSV package.
    Preview report data and download Excel. For engine diagnostics use
    <a routerLink="/dev">Developer</a>.
  </p>
</header>

<app-file-upload-zone [disabled]="busy()" (filesSelected)="onFiles($event)" />

@if (filename()) {
  <p class="meta">File: <strong>{{ filename() }}</strong></p>
}

<app-job-status-line [phase]="phase()" />

@if (error()) {
  <p class="error">{{ error() }}</p>
}

@if (downloadName()) {
  <div class="actions">
    <button type="button" class="btn btn--primary" (click)="download()">Download Excel</button>
  </div>
}

@if (debugRows().length) {
  <section class="preview">
    <h2>Report data preview</h2>
    <p class="hint">{{ debugRows().length }} metric slots</p>
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Table</th>
            <th>Template</th>
            <th>Row</th>
            <th>Col</th>
            <th>Variable ID</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          @for (row of debugRows(); track $index) {
            <tr>
              <td>{{ row.table }}</td>
              <td>{{ row.template }}</td>
              <td>{{ row.rowNr }}</td>
              <td>{{ row.columnNr }}</td>
              <td>{{ row.variableId }}</td>
              <td>{{ formatValue(row.value) }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </section>
}
